import { render, staticRenderFns } from "./SurveyControl.vue?vue&type=template&id=9c8540fe&"
import script from "./SurveyControl.vue?vue&type=script&lang=js&"
export * from "./SurveyControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports